// src/components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, type }) => {
  let isLoggedIn = false;

  try {
    if (type === "owner") {
      isLoggedIn = localStorage.getItem("owner_logged_in") === "true";
    } else if (type === "employee") {
      isLoggedIn = localStorage.getItem("employee_logged_in") === "true";
    }
  } catch (error) {
    console.warn("LocalStorage not available:", error);
    isLoggedIn = false;
  }

  // If not logged in → go to login page instead of crashing
  if (!isLoggedIn) {
    return <Navigate to="/admin-login" replace />;
  }

  return children;
};

export default ProtectedRoute;
